<template>
  <div class="common-button">
    <vs-button
      @click="onClick"
      :color="buttonColor"
      class="w-full"
      :class="{ disabled: disabled }"
      :style="btnStyle"
      :type="type"
      :text-color="buttonTextColor"
      :disabled="disabled"
      :icon="icon"
      >{{ title }}</vs-button
    >
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";

export default {
  name: "M.CommonButton",
  mixins: [ColorMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    click: {
      type: Function,
      required: true,
    },
    color: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: "filled",
    },
    textColor: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
    },
    btnStyle: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    showTitle() {
      return this.title && this.title.length > 0;
    },
    buttonColor() {
      if (!this.color) return this.AISEA_COLOR.BLUE;
      return this.color;
    },
    buttonTextColor() {
      // if (!this.textColor) return "";
      return this.textColor;
    },
  },
  methods: {
    onClick() {
      this.click();
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.common-button {
  --vs-primary: $aisea-blue;
  .disabled {
    background: $button-disabled !important;
  }
  .vs-button:disabled {
    opacity: 1;
  }
  i {
    z-index: 0 !important;
  }
}
</style>
